import { LangPositionAttendanceTargets, Spot } from '../../../../constant/languange'
import { connect, mapStateToProps } from '../../../../helpers/Common'

const PositionAttendanceTarget = ({ redux, val }) => {
  return (
    <div className='table-responsive my-3 text-center'>
      <table className={`table table-sm ${redux.darkModeOn ? 'table-dark bg-dark' : ''}`}>
        <thead>
          <tr>
            <th scope='col' className='text-center align-middle p-2'>{Spot}</th>
            <th scope='col' className='text-center align-middle p-2'>{LangPositionAttendanceTargets} (%)</th>
          </tr>
        </thead>
        <tbody>
          {val.map((item, i) => (
            <tr key={i}>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''} p-2`}>{item?.spot}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''} p-2`}>{item?.attendance_target}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default connect(mapStateToProps)(PositionAttendanceTarget)
